import { useState } from 'react'
import { IconButton, Menu, MenuItem, Typography } from '@mui/material'
import Icon from './icon'
import MenuModalItem from "./menuItem/menuItem"

type ActionMenuProps = {
  id: string
  menus: Array<{
    label: string
    onClick?: () => void
    onConfirm?: () => Promise<unknown>
    disabled?: boolean
    color?: string
  }>
}

export default function ActionMenu({ id, menus }: ActionMenuProps) {
  const [anchor, setAnchor] = useState<null | HTMLElement>(null)
  const openAnchor = Boolean(anchor)

  function onAction(event: React.MouseEvent<HTMLElement>) {
    setAnchor(event.currentTarget)
  }

  function onRemoveAnchor(callback?: () => void) {
    setAnchor(null)
    callback?.()
  }

  return (
    <>
      <IconButton
        id={`button-${id}`}
        aria-haspopup='true'
        aria-controls={openAnchor ? id : undefined}
        aria-expanded={openAnchor ? 'true' : undefined}
        onClick={(event) => onAction(event)}
      >
        <Icon icon='MoreHoriz' />
      </IconButton>
      <Menu
        id={`menu-${id}`}
        aria-labelledby={`button-${id}`}
        anchorEl={anchor}
        open={openAnchor}
        onClose={() => onRemoveAnchor()}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
      >
        {menus.map((menu) => {
          const { label, onClick, disabled, onConfirm } = menu

          function handleClickMenu() {
            onRemoveAnchor(onClick)
          }

          if (onConfirm) {
            return <MenuModalItem
              key={label}
              title={label}
              loading={disabled}
              onClick={onConfirm}
            >
              <Typography color={menu.color}>{label}</Typography>
            </MenuModalItem>
          }

          return (
            <MenuItem key={label} disabled={disabled} onClick={handleClickMenu}>
              <Typography color={menu.color}>{label}</Typography>
            </MenuItem>
          )
        })}
      </Menu>
    </>
  )
}
